// returns the current time zone as a string in IANA format

export const timezone = () => {
  return Intl.DateTimeFormat().resolvedOptions().timeZone
}
